/** Example placeholder text shown in empty form fields. */
export const PAYLOAD_BUILDER_PLACEHOLDERS = {
  loadJson: '{"slug": "status-match-uk-2026", "campaignId": "…"}',
  campaignId: 'e.g. a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  urlSlug: 'e.g. status-match-uk-2026',
  termsSlugMatch: 'e.g. societe-status-match-terms-and-conditions',
  termsSlugClaim: 'e.g. societe-terms-and-conditions',
  heroTitleMatch: 'e.g. Bring your status.',
  heroSubtitleMatch: "e.g. We'll match it.",
  heroDescription: 'e.g. Hold elite status with another program? Submit proof and book an eligible escape…',
  heroCtaText: 'e.g. Apply for Status Match',
  heroImageId: 'e.g. societe-status-match-hero-uk',
  heroTitleClaim: 'e.g. Claim your Société status',
  heroSubtitleClaim: 'e.g. Exclusive offer for members',
  programLogoImageId: 'e.g. match-campaign-logo-british-airways',
  conditionTitle: 'e.g. Once per member',
  conditionDescription: 'e.g. Available once per member, every 3 years.',
  stepTitle: 'e.g. Select program',
  stepDescription: 'e.g. Choose the loyalty program where you hold elite status.',
  challengeCardTitleSuffix: 'e.g. Status Match Offer',
  challengeCardSubtitleBefore: 'e.g. Complete the steps below to unlock ',
  challengeCardSubtitleAfter: 'e.g. status',
  backgroundColor: 'e.g. #ffffff',
  backgroundImageId: 'e.g. societe-card-background',
  successStepKey: 'e.g. always_pass',
  successStepTitle: 'e.g. Book and complete your stay',
  successStepDescription: 'e.g. At least 3 nights within 3 months',
  term: 'e.g. Status Match is available to select Société Bronze members…',
  faqQuestion: 'e.g. How do I apply?',
  faqAnswer: 'e.g. Select your program, upload proof, and book within 3 months.',
  partnerName: 'e.g. Singapore Medical Association',
  partnerLogoImageId: 'e.g. sma-partner-logo',
  secondaryTitle: 'e.g. Discover the Benefits of Société',
  secondarySubtitle: "e.g. Explore what's included with each status tier…",
  evidenceVerificationImageId: 'e.g. status-match-verification-image-test',
  evidenceHint: 'e.g. App screenshot',
  evidenceFormat: 'e.g. JPG',
  evidenceRequirement: 'e.g. Your full name',
} as const;
